import { render, staticRenderFns } from "./ProjectStats.vue?vue&type=template&id=84dfb816&scoped=true&"
import script from "./ProjectStats.vue?vue&type=script&lang=js&"
export * from "./ProjectStats.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStats.vue?vue&type=style&index=0&id=84dfb816&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dfb816",
  null
  
)

export default component.exports